// assets/main-article-related.js

(function () {
  const showMoreBtn = document.querySelector('.articles__show-more');
  
  if (!showMoreBtn) return;

  showMoreBtn.addEventListener('click', function () {
    const hiddenArticles = document.querySelectorAll('.related-article.hidden');
    
    // Show next 3 hidden articles
    for (let i = 0; i < 3 && i < hiddenArticles.length; i++) {
      hiddenArticles[i].classList.remove('hidden');
    }

    // Hide button if no more articles
    if (document.querySelectorAll('.related-article.hidden').length === 0) {
      showMoreBtn.classList.add('hidden');
    }
  });
})();